import React from "react";
import Navbar from "../../components/common/navbar/Navbar";
import ViewSales from "../../components/sales/ViewSales";

const ViewSalesPage = () => {
    return (
        <>
            <section className="bajaj_main_block">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 p-0">
                            <Navbar content="VIEW ORDER" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 p-0">
                            <ViewSales />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ViewSalesPage;
